export default __webpack_public_path__ + "static/media/Snd_Z_Starts.233e8cf4.mp3";